module.exports = __webpack_public_path__ + "img/jboard_icon-37.7a1130ba.png";